
!function() {
  var script = document.createElement('script');
  script.src = 'https://config.gorgias.chat/gorgias-chat-bundle-loader.js?applicationId=305';
  script.id = 'gorgias-chat-bundle';

  document.body.appendChild(script)
  
  window.GorgiasChat={}
  var initialization = new Promise(function(resolve, reject) {
    window.GorgiasChat.resolve = resolve
  })
  window.GorgiasChat.init = function() { return initialization; }
}();


var repetitionCount = 0;
var isWindowStyleAppended = false
var gorgiasChatInterval = window.setTimeout(function() {

  var container = document.querySelector('#gorgias-chat-container');
  var chatButtonHead = container?.querySelector('#chat-button')?.contentWindow.document.querySelector('head');
  var chatCampaignsHead = container?.querySelector('#chat-campaigns')?.contentWindow.document.querySelector('head');
  var chatWindowHead = container?.querySelector('#chat-window')?.contentWindow.document.querySelector('head');
  if (chatButtonHead?.children.length && !isWindowStyleAppended) {
    var buttonStyle = document.createElement('style');
    buttonStyle.textContent = '.chat-title {color: black}'; // the custom CSS for the chat button
    chatButtonHead.appendChild(buttonStyle);     

    var windowStyles = document.createElement('style');
    windowStyles.textContent = `
      .chat-title{
        color:black!important;
      }
      .message-window-iframe-8xt605 h2{
        color:black!important;
      }
      .message-window-iframe-icdr3r{
        display:none!important;
      }
      .message-window-iframe-14u6952 svg path{
        fill:black;
      }
      .message-window-iframe-14u6952{
        color:black!important;
      }
      .message-window-iframe-8l6hao{
        display:none;
      }
      .message-window-iframe-1rh94dl{
        background:#edc8a3!important;
        color:black!important;
        border:0!important;
      }
      .go-back-btn svg path{
        fill:black!important;
      }
    `
    chatWindowHead.appendChild(windowStyles);
    isWindowStyleAPpended = true;
}
},1000)